import React from "react";
import { Button, Col, Icon, Modal, Row } from "antd";

import { observer } from "mobx-react";
import stories from "../data/storiesChildToParent";

const imgs = {
  aoyama: {
    a: require("../imgs/stories/aoyama/child_to_parent/a.no1.jpg"),
    b: require("../imgs/stories/aoyama/child_to_parent/b.no1.jpg"),
    c: require("../imgs/stories/aoyama/child_to_parent/c.no1.jpg"),
    d: require("../imgs/stories/aoyama/child_to_parent/d.no1.jpg"),
    e: require("../imgs/stories/aoyama/child_to_parent/e.no1.jpg"),
    f: require("../imgs/stories/aoyama/child_to_parent/f.no1.jpg"),
    g: require("../imgs/stories/aoyama/child_to_parent/g.no1.jpg"),
    h: require("../imgs/stories/aoyama/child_to_parent/h.no1.jpg"),
    i: require("../imgs/stories/aoyama/child_to_parent/i.no1.jpg"),
    j: require("../imgs/stories/aoyama/child_to_parent/j.no1.jpg"),
    k: require("../imgs/stories/aoyama/child_to_parent/k.no1.jpg"),
    l: require("../imgs/stories/aoyama/child_to_parent/l.no1.jpg"),
    m: require("../imgs/stories/aoyama/child_to_parent/m.no1.jpg"),
    n: require("../imgs/stories/aoyama/child_to_parent/n.no1.jpg"),
    o: require("../imgs/stories/aoyama/child_to_parent/o.no1.jpg"),
    p: require("../imgs/stories/aoyama/child_to_parent/p.no1.jpg"),
    q: require("../imgs/stories/aoyama/child_to_parent/q.no1.jpg"),
    r: require("../imgs/stories/aoyama/child_to_parent/r.no1.jpg"),
    s: require("../imgs/stories/aoyama/child_to_parent/s.no1.jpg"),
    t: require("../imgs/stories/aoyama/child_to_parent/t.no1.jpg"),
    u: require("../imgs/stories/aoyama/child_to_parent/u.no1.jpg"),
    v: require("../imgs/stories/aoyama/child_to_parent/v.no1.jpg"),
    w: require("../imgs/stories/aoyama/child_to_parent/w.no1.jpg"),
    x1: require("../imgs/stories/aoyama/child_to_parent/x1.no1.jpg"),
    x2: require("../imgs/stories/aoyama/child_to_parent/x2.no1.jpg"),
    x3: require("../imgs/stories/aoyama/child_to_parent/x3.no1.jpg"),
    x4: require("../imgs/stories/aoyama/child_to_parent/x4.no1.jpg"),
    x5: require("../imgs/stories/aoyama/child_to_parent/x5.no1.jpg"),
    y: require("../imgs/stories/aoyama/child_to_parent/y.no1.jpg"),
    z: require("../imgs/stories/aoyama/child_to_parent/z.no1.jpg"),
    aa: require("../imgs/stories/aoyama/child_to_parent/aa.no1.jpg"),
    ab1: require("../imgs/stories/aoyama/child_to_parent/ab1.no1.jpg"),
    ab2: require("../imgs/stories/aoyama/child_to_parent/ab2.no1.jpg"),
    ab3: require("../imgs/stories/aoyama/child_to_parent/ab3.no1.jpg"),
    ac: require("../imgs/stories/aoyama/child_to_parent/ac.no1.jpg"),
    ad: require("../imgs/stories/aoyama/child_to_parent/ad.no1.jpg"),

    ai2: require("../imgs/stories/aoyama/child_to_parent/a.no2.jpg"),
    bi2: require("../imgs/stories/aoyama/child_to_parent/b.no2.jpg"),
    ci2: require("../imgs/stories/aoyama/child_to_parent/c.no2.jpg"),
    di2: require("../imgs/stories/aoyama/child_to_parent/d.no2.jpg"),
    ei2: require("../imgs/stories/aoyama/child_to_parent/e.no2.jpg"),
    fi2: require("../imgs/stories/aoyama/child_to_parent/f.no2.jpg"),
    gi2: require("../imgs/stories/aoyama/child_to_parent/g.no2.jpg"),
    hi2: require("../imgs/stories/aoyama/child_to_parent/h.no2.jpg"),
    ii2: require("../imgs/stories/aoyama/child_to_parent/i.no2.jpg"),
    ji2: require("../imgs/stories/aoyama/child_to_parent/j.no2.jpg"),
    ki2: require("../imgs/stories/aoyama/child_to_parent/k.no2.jpg"),
    li2: require("../imgs/stories/aoyama/child_to_parent/l.no2.jpg"),
    mi2: require("../imgs/stories/aoyama/child_to_parent/m.no2.jpg"),
    ni2: require("../imgs/stories/aoyama/child_to_parent/n.no2.jpg"),
    oi2: require("../imgs/stories/aoyama/child_to_parent/o.no2.jpg"),
    pi2: require("../imgs/stories/aoyama/child_to_parent/p.no2.jpg"),
    qi2: require("../imgs/stories/aoyama/child_to_parent/q.no2.jpg"),
    ri2: require("../imgs/stories/aoyama/child_to_parent/r.no2.jpg"),
    si2: require("../imgs/stories/aoyama/child_to_parent/s.no2.jpg"),
    ti2: require("../imgs/stories/aoyama/child_to_parent/t.no2.jpg"),
    ui2: require("../imgs/stories/aoyama/child_to_parent/u.no2.jpg"),
    vi2: require("../imgs/stories/aoyama/child_to_parent/v.no2.jpg"),
    wi2: require("../imgs/stories/aoyama/child_to_parent/w.no2.jpg"),
    x1i2: require("../imgs/stories/aoyama/child_to_parent/x1.no2.jpg"),
    x2i2: require("../imgs/stories/aoyama/child_to_parent/x2.no2.jpg"),
    yi2: require("../imgs/stories/aoyama/child_to_parent/y.no2.jpg"),
    zi2: require("../imgs/stories/aoyama/child_to_parent/z.no2.jpg"),
    aai2: require("../imgs/stories/aoyama/child_to_parent/aa.no2.jpg"),
    abi2: require("../imgs/stories/aoyama/child_to_parent/ab.no2.jpg"),
    aci2: require("../imgs/stories/aoyama/child_to_parent/ac.no2.jpg"),
    adi2: require("../imgs/stories/aoyama/child_to_parent/ad.no2.jpg"),

    ae: require("../imgs/stories/aoyama/child_to_parent/ae.no1.jpg"),
    af: require("../imgs/stories/aoyama/child_to_parent/af.no1.jpg"),
    ag: require("../imgs/stories/aoyama/child_to_parent/ag.no1.jpg"),
    ah: require("../imgs/stories/aoyama/child_to_parent/ah.no1.jpg"),
    ai: require("../imgs/stories/aoyama/child_to_parent/ai.no1.jpg"),
    aj: require("../imgs/stories/aoyama/child_to_parent/aj.no1.jpg"),
    ak: require("../imgs/stories/aoyama/child_to_parent/ak.no1.jpg"),
    al: require("../imgs/stories/aoyama/child_to_parent/al.no1.jpg"),
    am: require("../imgs/stories/aoyama/child_to_parent/am.no1.jpg"),
    an: require("../imgs/stories/aoyama/child_to_parent/an.no1.jpg"),
    ao: require("../imgs/stories/aoyama/child_to_parent/ao.no1.jpg"),
    ap: require("../imgs/stories/aoyama/child_to_parent/ap.no1.jpg"),
    aq: require("../imgs/stories/aoyama/child_to_parent/aq.no1.jpg"),
    ar: require("../imgs/stories/aoyama/child_to_parent/ar.no1.jpg"),
    as: require("../imgs/stories/aoyama/child_to_parent/as.no1.jpg"),
    at: require("../imgs/stories/aoyama/child_to_parent/at.no1.jpg"),
    au: require("../imgs/stories/aoyama/child_to_parent/au.no1.jpg"),
    av: require("../imgs/stories/aoyama/child_to_parent/av.no1.jpg"),
    aw: require("../imgs/stories/aoyama/child_to_parent/aw.no1.jpg"),
    ax: require("../imgs/stories/aoyama/child_to_parent/ax.no1.jpg"),
    ay: require("../imgs/stories/aoyama/child_to_parent/ay.no1.jpg"),
    az: require("../imgs/stories/aoyama/child_to_parent/az.no1.jpg"),
    ba: require("../imgs/stories/aoyama/child_to_parent/ba.no1.jpg"),
    bb1: require("../imgs/stories/aoyama/child_to_parent/bb1.no1.jpg"),
    bb2: require("../imgs/stories/aoyama/child_to_parent/bb2.no1.jpg"),
    bb3: require("../imgs/stories/aoyama/child_to_parent/bb3.no1.jpg"),
    bb4: require("../imgs/stories/aoyama/child_to_parent/bb4.no1.jpg"),
    bb5: require("../imgs/stories/aoyama/child_to_parent/bb5.no1.jpg"),
    bc: require("../imgs/stories/aoyama/child_to_parent/bc.no1.jpg"),
    bd: require("../imgs/stories/aoyama/child_to_parent/bd.no1.jpg"),
    be: require("../imgs/stories/aoyama/child_to_parent/be.no1.jpg"),
    bf1: require("../imgs/stories/aoyama/child_to_parent/bf1.no1.jpg"),
    bf2: require("../imgs/stories/aoyama/child_to_parent/bf2.no1.jpg"),
    bf3: require("../imgs/stories/aoyama/child_to_parent/bf3.no1.jpg"),
    bg: require("../imgs/stories/aoyama/child_to_parent/bg.no1.jpg"),
    bh: require("../imgs/stories/aoyama/child_to_parent/bh.no1.jpg"),

    aei2: require("../imgs/stories/aoyama/child_to_parent/ae.no2.jpg"),
    afi2: require("../imgs/stories/aoyama/child_to_parent/af.no2.jpg"),
    agi2: require("../imgs/stories/aoyama/child_to_parent/ag.no2.jpg"),
    ahi2: require("../imgs/stories/aoyama/child_to_parent/ah.no2.jpg"),
    aii2: require("../imgs/stories/aoyama/child_to_parent/ai.no2.jpg"),
    aji2: require("../imgs/stories/aoyama/child_to_parent/aj.no2.jpg"),
    aki2: require("../imgs/stories/aoyama/child_to_parent/ak.no2.jpg"),
    ali2: require("../imgs/stories/aoyama/child_to_parent/al.no2.jpg"),
    ami2: require("../imgs/stories/aoyama/child_to_parent/am.no2.jpg"),
    ani2: require("../imgs/stories/aoyama/child_to_parent/an.no2.jpg"),
    aoi2: require("../imgs/stories/aoyama/child_to_parent/ao.no2.jpg"),
    api2: require("../imgs/stories/aoyama/child_to_parent/ap.no2.jpg"),
    aqi2: require("../imgs/stories/aoyama/child_to_parent/aq.no2.jpg"),
    ari2: require("../imgs/stories/aoyama/child_to_parent/ar.no2.jpg"),
    asi2: require("../imgs/stories/aoyama/child_to_parent/as.no2.jpg"),
    ati2: require("../imgs/stories/aoyama/child_to_parent/at.no2.jpg"),
    aui2: require("../imgs/stories/aoyama/child_to_parent/au.no2.jpg"),
    avi2: require("../imgs/stories/aoyama/child_to_parent/av.no2.jpg"),
    awi2: require("../imgs/stories/aoyama/child_to_parent/aw.no2.jpg"),
    axi2: require("../imgs/stories/aoyama/child_to_parent/ax.no2.jpg"),
    ayi2: require("../imgs/stories/aoyama/child_to_parent/ay.no2.jpg"),
    azi2: require("../imgs/stories/aoyama/child_to_parent/az.no2.jpg"),
    bai2: require("../imgs/stories/aoyama/child_to_parent/ba.no2.jpg"),
    bb1i2: require("../imgs/stories/aoyama/child_to_parent/bb1.no2.jpg"),
    bb2i2: require("../imgs/stories/aoyama/child_to_parent/bb2.no2.jpg"),
    bci2: require("../imgs/stories/aoyama/child_to_parent/bc.no2.jpg"),
    bdi2: require("../imgs/stories/aoyama/child_to_parent/bd.no2.jpg"),
    bei2: require("../imgs/stories/aoyama/child_to_parent/be.no2.jpg"),
    bfi2: require("../imgs/stories/aoyama/child_to_parent/bf.no2.jpg"),
    bgi2: require("../imgs/stories/aoyama/child_to_parent/bg.no2.jpg"),
    bhi2: require("../imgs/stories/aoyama/child_to_parent/bh.no2.jpg"),
  },
  okuta: {
    a: require("../imgs/stories/okuta/child_to_parent/a.no1.jpg"),
    b: require("../imgs/stories/okuta/child_to_parent/b.no1.jpg"),
    c: require("../imgs/stories/okuta/child_to_parent/c.no1.jpg"),
    d: require("../imgs/stories/okuta/child_to_parent/d.no1.jpg"),
    e: require("../imgs/stories/okuta/child_to_parent/e.no1.jpg"),
    f: require("../imgs/stories/okuta/child_to_parent/f.no1.jpg"),
    g: require("../imgs/stories/okuta/child_to_parent/g.no1.jpg"),
    h: require("../imgs/stories/okuta/child_to_parent/h.no1.jpg"),
    i: require("../imgs/stories/okuta/child_to_parent/i.no1.jpg"),
    j: require("../imgs/stories/okuta/child_to_parent/j.no1.jpg"),
    k: require("../imgs/stories/okuta/child_to_parent/k.no1.jpg"),
    l: require("../imgs/stories/okuta/child_to_parent/l.no1.jpg"),
    m: require("../imgs/stories/okuta/child_to_parent/m.no1.jpg"),
    n: require("../imgs/stories/okuta/child_to_parent/n.no1.jpg"),
    o: require("../imgs/stories/okuta/child_to_parent/o.no1.jpg"),
    p: require("../imgs/stories/okuta/child_to_parent/p.no1.jpg"),
    q: require("../imgs/stories/okuta/child_to_parent/q.no1.jpg"),
    r: require("../imgs/stories/okuta/child_to_parent/r.no1.jpg"),
    s: require("../imgs/stories/okuta/child_to_parent/s.no1.jpg"),
    t: require("../imgs/stories/okuta/child_to_parent/t.no1.jpg"),
    u: require("../imgs/stories/okuta/child_to_parent/u.no1.jpg"),
    v: require("../imgs/stories/okuta/child_to_parent/v.no1.jpg"),
    w: require("../imgs/stories/okuta/child_to_parent/w.no1.jpg"),
    x1: require("../imgs/stories/okuta/child_to_parent/x1.no1.jpg"),
    x2: require("../imgs/stories/okuta/child_to_parent/x2.no1.jpg"),
    x3: require("../imgs/stories/okuta/child_to_parent/x3.no1.jpg"),
    x4: require("../imgs/stories/okuta/child_to_parent/x4.no1.jpg"),
    x5: require("../imgs/stories/okuta/child_to_parent/x5.no1.jpg"),
    y: require("../imgs/stories/okuta/child_to_parent/y.no1.jpg"),
    z: require("../imgs/stories/okuta/child_to_parent/z.no1.jpg"),
    aa: require("../imgs/stories/okuta/child_to_parent/aa.no1.jpg"),
    ab1: require("../imgs/stories/okuta/child_to_parent/ab1.no1.jpg"),
    ab2: require("../imgs/stories/okuta/child_to_parent/ab2.no1.jpg"),
    ab3: require("../imgs/stories/okuta/child_to_parent/ab3.no1.jpg"),
    ac: require("../imgs/stories/okuta/child_to_parent/ac.no1.jpg"),
    ad: require("../imgs/stories/okuta/child_to_parent/ad.no1.jpg"),

    ai2: require("../imgs/stories/okuta/child_to_parent/a.no2.jpg"),
    bi2: require("../imgs/stories/okuta/child_to_parent/b.no2.jpg"),
    ci2: require("../imgs/stories/okuta/child_to_parent/c.no2.jpg"),
    di2: require("../imgs/stories/okuta/child_to_parent/d.no2.jpg"),
    e1i2: require("../imgs/stories/okuta/child_to_parent/e1.no2.jpg"),
    e2i2: require("../imgs/stories/okuta/child_to_parent/e2.no2.jpg"),
    fi2: require("../imgs/stories/okuta/child_to_parent/f.no2.jpg"),
    gi2: require("../imgs/stories/okuta/child_to_parent/g.no2.jpg"),
    hi2: require("../imgs/stories/okuta/child_to_parent/h.no2.jpg"),
    ii2: require("../imgs/stories/okuta/child_to_parent/i.no2.jpg"),
    ji2: require("../imgs/stories/okuta/child_to_parent/j.no2.jpg"),
    ki2: require("../imgs/stories/okuta/child_to_parent/k.no2.jpg"),
    li2: require("../imgs/stories/okuta/child_to_parent/l.no2.jpg"),
    mi2: require("../imgs/stories/okuta/child_to_parent/m.no2.jpg"),
    ni2: require("../imgs/stories/okuta/child_to_parent/n.no2.jpg"),
    oi2: require("../imgs/stories/okuta/child_to_parent/o.no2.jpg"),
    pi2: require("../imgs/stories/okuta/child_to_parent/p.no2.jpg"),
    qi2: require("../imgs/stories/okuta/child_to_parent/q.no2.jpg"),
    ri2: require("../imgs/stories/okuta/child_to_parent/r.no2.jpg"),
    si2: require("../imgs/stories/okuta/child_to_parent/s.no2.jpg"),
    ti2: require("../imgs/stories/okuta/child_to_parent/t.no2.jpg"),
    ui2: require("../imgs/stories/okuta/child_to_parent/u.no2.jpg"),
    vi2: require("../imgs/stories/okuta/child_to_parent/v.no2.jpg"),
    wi2: require("../imgs/stories/okuta/child_to_parent/w.no2.jpg"),
    x1i2: require("../imgs/stories/okuta/child_to_parent/x1.no2.jpg"),
    x2i2: require("../imgs/stories/okuta/child_to_parent/x2.no2.jpg"),
    x3i2: require("../imgs/stories/okuta/child_to_parent/x3.no2.jpg"),
    x4i2: require("../imgs/stories/okuta/child_to_parent/x4.no2.jpg"),
    x5i2: require("../imgs/stories/okuta/child_to_parent/x5.no2.jpg"),
    yi2: require("../imgs/stories/okuta/child_to_parent/y.no2.jpg"),
    zi2: require("../imgs/stories/okuta/child_to_parent/z.no2.jpg"),
    aai2: require("../imgs/stories/okuta/child_to_parent/aa.no2.jpg"),
    ab1i2: require("../imgs/stories/okuta/child_to_parent/ab1.no2.jpg"),
    ab2i2: require("../imgs/stories/okuta/child_to_parent/ab2.no2.jpg"),
    aci2: require("../imgs/stories/okuta/child_to_parent/ac.no2.jpg"),
    adi2: require("../imgs/stories/okuta/child_to_parent/ad.no2.jpg"),

    ae: require("../imgs/stories/okuta/child_to_parent/ae.no1.jpg"),
    af: require("../imgs/stories/okuta/child_to_parent/af.no1.jpg"),
    ag: require("../imgs/stories/okuta/child_to_parent/ag.no1.jpg"),
    ah: require("../imgs/stories/okuta/child_to_parent/ah.no1.jpg"),
    ai: require("../imgs/stories/okuta/child_to_parent/ai.no1.jpg"),
    aj: require("../imgs/stories/okuta/child_to_parent/aj.no1.jpg"),
    ak: require("../imgs/stories/okuta/child_to_parent/ak.no1.jpg"),
    al: require("../imgs/stories/okuta/child_to_parent/al.no1.jpg"),
    am: require("../imgs/stories/okuta/child_to_parent/am.no1.jpg"),
    an: require("../imgs/stories/okuta/child_to_parent/an.no1.jpg"),
    ao: require("../imgs/stories/okuta/child_to_parent/ao.no1.jpg"),
    ap: require("../imgs/stories/okuta/child_to_parent/ap.no1.jpg"),
    aq: require("../imgs/stories/okuta/child_to_parent/aq.no1.jpg"),
    ar: require("../imgs/stories/okuta/child_to_parent/ar.no1.jpg"),
    as: require("../imgs/stories/okuta/child_to_parent/as.no1.jpg"),
    at: require("../imgs/stories/okuta/child_to_parent/at.no1.jpg"),
    au: require("../imgs/stories/okuta/child_to_parent/au.no1.jpg"),
    av: require("../imgs/stories/okuta/child_to_parent/av.no1.jpg"),
    aw: require("../imgs/stories/okuta/child_to_parent/aw.no1.jpg"),
    ax: require("../imgs/stories/okuta/child_to_parent/ax.no1.jpg"),
    ay: require("../imgs/stories/okuta/child_to_parent/ay.no1.jpg"),
    az: require("../imgs/stories/okuta/child_to_parent/az.no1.jpg"),
    ba: require("../imgs/stories/okuta/child_to_parent/ba.no1.jpg"),
    bb1: require("../imgs/stories/okuta/child_to_parent/bb1.no1.jpg"),
    bb2: require("../imgs/stories/okuta/child_to_parent/bb2.no1.jpg"),
    bb3: require("../imgs/stories/okuta/child_to_parent/bb3.no1.jpg"),
    bb4: require("../imgs/stories/okuta/child_to_parent/bb4.no1.jpg"),
    bb5: require("../imgs/stories/okuta/child_to_parent/bb5.no1.jpg"),
    bc: require("../imgs/stories/okuta/child_to_parent/bc.no1.jpg"),
    bd: require("../imgs/stories/okuta/child_to_parent/bd.no1.jpg"),
    be: require("../imgs/stories/okuta/child_to_parent/be.no1.jpg"),
    bf1: require("../imgs/stories/okuta/child_to_parent/bf1.no1.jpg"),
    bf2: require("../imgs/stories/okuta/child_to_parent/bf2.no1.jpg"),
    bf3: require("../imgs/stories/okuta/child_to_parent/bf3.no1.jpg"),
    bg: require("../imgs/stories/okuta/child_to_parent/bg.no1.jpg"),
    bh: require("../imgs/stories/okuta/child_to_parent/bh.no1.jpg"),

    aei2: require("../imgs/stories/okuta/child_to_parent/ae.no2.jpg"),
    afi2: require("../imgs/stories/okuta/child_to_parent/af.no2.jpg"),
    agi2: require("../imgs/stories/okuta/child_to_parent/ag.no2.jpg"),
    ahi2: require("../imgs/stories/okuta/child_to_parent/ah.no2.jpg"),
    ai1i2: require("../imgs/stories/okuta/child_to_parent/ai1.no2.jpg"),
    ai2i2: require("../imgs/stories/okuta/child_to_parent/ai2.no2.jpg"),
    aji2: require("../imgs/stories/okuta/child_to_parent/aj.no2.jpg"),
    aki2: require("../imgs/stories/okuta/child_to_parent/ak.no2.jpg"),
    ali2: require("../imgs/stories/okuta/child_to_parent/al.no2.jpg"),
    ami2: require("../imgs/stories/okuta/child_to_parent/am.no2.jpg"),
    ani2: require("../imgs/stories/okuta/child_to_parent/an.no2.jpg"),
    aoi2: require("../imgs/stories/okuta/child_to_parent/ao.no2.jpg"),
    api2: require("../imgs/stories/okuta/child_to_parent/ap.no2.jpg"),
    aqi2: require("../imgs/stories/okuta/child_to_parent/aq.no2.jpg"),
    ari2: require("../imgs/stories/okuta/child_to_parent/ar.no2.jpg"),
    asi2: require("../imgs/stories/okuta/child_to_parent/as.no2.jpg"),
    ati2: require("../imgs/stories/okuta/child_to_parent/at.no2.jpg"),
    aui2: require("../imgs/stories/okuta/child_to_parent/au.no2.jpg"),
    avi2: require("../imgs/stories/okuta/child_to_parent/av.no2.jpg"),
    awi2: require("../imgs/stories/okuta/child_to_parent/aw.no2.jpg"),
    axi2: require("../imgs/stories/okuta/child_to_parent/ax.no2.jpg"),
    ayi2: require("../imgs/stories/okuta/child_to_parent/ay.no2.jpg"),
    azi2: require("../imgs/stories/okuta/child_to_parent/az.no2.jpg"),
    bai2: require("../imgs/stories/okuta/child_to_parent/ba.no2.jpg"),
    bb1i2: require("../imgs/stories/okuta/child_to_parent/bb1.no2.jpg"),
    bb2i2: require("../imgs/stories/okuta/child_to_parent/bb2.no2.jpg"),
    bb3i2: require("../imgs/stories/okuta/child_to_parent/bb3.no2.jpg"),
    bb4i2: require("../imgs/stories/okuta/child_to_parent/bb4.no2.jpg"),
    bb5i2: require("../imgs/stories/okuta/child_to_parent/bb5.no2.jpg"),
    bci2: require("../imgs/stories/okuta/child_to_parent/bc.no2.jpg"),
    bdi2: require("../imgs/stories/okuta/child_to_parent/bd.no2.jpg"),
    bei2: require("../imgs/stories/okuta/child_to_parent/be.no2.jpg"),
    bf1i2: require("../imgs/stories/okuta/child_to_parent/bf1.no2.jpg"),
    bf2i2: require("../imgs/stories/okuta/child_to_parent/bf2.no2.jpg"),
    bgi2: require("../imgs/stories/okuta/child_to_parent/bg.no2.jpg"),
    bhi2: require("../imgs/stories/okuta/child_to_parent/bh.no2.jpg"),
  },
};

// タイトル設定
const storyTitles = {
  aoyama: {
    a: "1：成長の記録をありがとう",
    b: "2：小さな成功体験をありがとう",
    c: "3：いつも安心させてくれてありがとう",
    d: "4：いつも笑顔でいてくれてありがとう",
    e: "5：厳しさという優しさをありがとう",
    f: "6：親子の時間を大切にしてくれてありがとう",
    g: "7：単身赴任で家族を支えてくれてありがとう",
    h: "8：愛情たっぷりのお弁当をありがとう",
    i: "9：伴走してくれてありがとう",
    j: "10：機会と選択肢をくれてありがとう",
    k: "11：心配してくれてありがとう",
    l: "12：無償の愛を注いでくれてありがとう",
    m: "13：信じて応援してくれてありがとう",
    n: "14：一緒に喜んでくれてありがとう",
    o: "15：悲しみを分けあってくれてありがとう",
    p: "16：頼もしくいてくれてありがとう",
    q: "17：いつも支えてくれてありがとう",
    r: "18：一番の理解者でいてくれてありがとう",
    s: "19：いつでも温かく迎え入れてくれてありがとう",
    t: "20：人生が変わる言葉をありがとう",
    u: "21：心配させないように気遣ってくれてありがとう",
    v: "22：素敵なギフトをありがとう",
    w: "23：大人として認めてくれてありがとう",
    x: "24：個性を尊重してくれてありがとう",
    y: "25：縛らず自由でいさせてくれてありがとう",
    z: "26：最高の環境を与えてくれてありがとう",
    aa: "27：理想の親でいてくれてありがとう",
    ab: "28：孫を溺愛してくれてありがとう",
    ac: "29：元気でいてくれてありがとう",
    ad: "30：私の大切な人を気にかけてくれてありがとう",

    ae: "1：成長の記録を残してくれてありがとう",
    af: "2：たくさんの小さな成功体験をありがとう",
    ag: "3：いつも安心させてくれてありがとう",
    ah: "4：いつも笑顔でいてくれてありがとう",
    ai: "5：厳しさという優しさをありがとう",
    aj: "6：親子の時間を大切にしてくれてありがとう",
    ak: "7：単身赴任で家族を支えてくれてありがとう",
    al: "8：愛情たっぷりのお弁当をありがとう",
    am: "9：伴走してくれてありがとう",
    an: "10：機会と選択肢をくれてありがとう",
    ao: "11：心配してくれてありがとう",
    ap: "12：無償の愛を注いでくれてありがとう",
    aq: "13：信じて応援してくれてありがとう",
    ar: "14：一緒に喜んでくれてありがとう",
    as: "15：悲しみを分けあってくれてありがとう",
    at: "16：頼もしくいてくれてありがとう",
    au: "17：いつも支えてくれてありがとう",
    av: "18：一番の理解者でいてくれてありがとう",
    aw: "19：いつでも温かく迎え入れてくれてありがとう",
    ax: "20：人生が変わる言葉をありがとう",
    ay: "21：心配させないように気遣ってくれてありがとう",
    az: "22：素敵なギフトをありがとう",
    ba: "23：大人として認めてくれてありがとう",
    bb: "24：個性を尊重してくれてありがとう",
    bc: "25：縛らず自由でいさせてくれてありがとう",
    bd: "26：最高の環境を与えてくれてありがとう",
    be: "27：理想の親でいてくれてありがとう",
    bf: "28：孫を溺愛してくれてありがとう",
    bg: "29：元気でいてくれてありがとう",
    bh: "30：私の大切な人を気にかけてくれてありがとう",
  },
  okuta: {
    a: "1：名前に想いを込めてくれてありがとう",
    b: "2：成長の記録をありがとう",
    c: "3：小さな成功体験をありがとう",
    d: "4：いつも安心させてくれてありがとう",
    e: "5：いつも笑顔でいてくれてありがとう",
    f: "6：厳しくしつけてくれてありがとう",
    g: "7：親子の時間を大切にしてくれてありがとう",
    h: "8：単身赴任で家族を支えてくれてありがとう",
    i: "9：愛情たっぷりのお弁当をありがとう",
    j: "10：伴走してくれてありがとう",
    k: "11：機会と選択肢をくれてありがとう",
    l: "12：守ってくれてありがとう",
    m: "13：無償の愛を注いでくれてありがとう",
    n: "14：孤独にしないでくれてありがとう",
    o: "15：信じて応援してくれてありがとう",
    p: "16：一緒に喜んでくれてありがとう",
    q: "17：頼もしくいてくれてありがとう",
    r: "18：いつも支えてくれてくれてありがとう",
    s: "19：一番の理解者でいてくれてありがとう",
    t: "20：いつでも温かく迎え入れてくれてありがとう",
    u: "21：人生が変わる言葉をありがとう",
    v: "22：素敵なギフトをありがとう",
    w: "23：大人として認めてくれてありがとう",
    x: "24：個性を尊重してくれてありがとう",
    y: "25：縛らず自由でいさせてくれてありがとう",
    z: "26：最高の環境を与えてくれてありがとう",
    aa: "27：理想の親でいてくれてありがとう",
    ab: "28：孫を溺愛してくれてありがとう",
    ac: "29：元気でいてくれてありがとう",
    ad: "30：私の大切な人を気にかけてくれてありがとう",

    ae: "1：名前に想いを込めてくれてありがとう",
    af: "2：成長の記録をありがとう",
    ag: "3：小さな成功体験をありがとう",
    ah: "4：いつも安心させてくれてありがとう",
    ai: "5：いつも笑顔でいてくれてありがとう",
    aj: "6：厳しくしつけてくれてありがとう",
    ak: "7：親子の時間を大切にしてくれてありがとう",
    al: "8：単身赴任で家族を支えてくれてありがとう",
    am: "9：愛情たっぷりのお弁当をありがとう",
    an: "10：伴走してくれてありがとう",
    ao: "11：機会と選択肢をくれてありがとう",
    ap: "12：守ってくれてありがとう",
    aq: "13：無償の愛を注いでくれてありがとう",
    ar: "14：孤独にしないでくれてありがとう",
    as: "15：信じて応援してくれてありがとう",
    at: "16：一緒に喜んでくれてありがとう",
    au: "17：頼もしくいてくれてありがとう",
    av: "18：いつも支えてくれてくれてありがとう",
    aw: "19：一番の理解者でいてくれてありがとう",
    ax: "20：いつでも温かく迎え入れてくれてありがとう",
    ay: "21：人生が変わる言葉をありがとう",
    az: "22：素敵なギフトをありがとう",
    ba: "23：大人として認めてくれてありがとう",
    bb: "24：個性を尊重してくれてありがとう",
    bc: "25：縛らず自由でいさせてくれてありがとう",
    bd: "26：最高の環境を与えてくれてありがとう",
    be: "27：理想の親でいてくれてありがとう",
    bf: "28：孫を溺愛してくれてありがとう",
    bg: "29：元気でいてくれてありがとう",
    bh: "30：私の大切な人を気にかけてくれてありがとう",
  },
};

const adapt = (story, book) => { // 入力内容に応じてストーリー内の文字列に反映
  const { artistName, childToParent } = book;
  story = story.replace(/＜ID-3＞/g, childToParent.dadName);
  story = story.replace(/＜ID-4＞/g, childToParent.lifeChangingWordsFromDad);
  story = story.replace(/＜ID-5＞/g, childToParent.momName);
  story = story.replace(/＜ID-6＞/g, childToParent.lifeChangingWordsFromMom);
  const children = childToParent.children === 1
    ? childToParent.childName
    : '子どもたち';
  story = story.replace(/＜ID-12＞/g, children);
  // TODO: 判定は作者に依存している。増えたときに考慮必要かも
  /* if (artistName === "aoyama") {
    story = story.replace(/＜ID-3＞/g, childToParent.dadName);
    story = story.replace(/＜ID-4＞/g, childToParent.lifeChangingWordsFromDad);
    story = story.replace(/＜ID-5＞/g, childToParent.momName);
    story = story.replace(/＜ID-6＞/g, childToParent.lifeChangingWordsFromMom);
    const children = childToParent.children === 1
      ? childToParent.childName
      : '子どもたち';
    story = story.replace(/＜ID-12＞/g, children);
  } else { // okuta
    // 今回追加分
    story = story.replace(/＜ID-3＞/g, childToParent.dadName);
    story = story.replace(/＜ID-4＞/g, childToParent.lifeChangingWordsFromDad);
    story = story.replace(/＜ID-5＞/g, childToParent.momName);
    story = story.replace(/＜ID-6＞/g, childToParent.lifeChangingWordsFromMom);
    const children = childToParent.children === 1
      ? childToParent.childName
      : '子どもたち';
    story = story.replace(/＜ID-12＞/g, children);
  } */
  return story;
};

const getImg = (book, id, is2Page = false) => {
  // console.log(id);
  const artistName = book.artistName; // TODO: okutaは後日追加予定
  const hasSibling = book.childToParent.sibling; // story 24-2 x bb
  const hasSiblingTemplate = book.childToParent.siblingTemplate; // story 24-1 x bb

  const hasChildren = book.childToParent.children; // story 28 ab bf
  // const a = book.artistName !== "" ? book.artistName : "aoyama",
  //   withTemplate = `${id}${book.childToParent.children}${is2Page ? 'i2' : ''}`,
  //   withoutTemplate = `${id}${is2Page ? 'i2' : ''}`;
  // console.log('getImg', withTemplate, withoutTemplate);
  // const img = imgs[a][withTemplate] || imgs[a][withoutTemplate];
  const productType = book.productType;

  if (artistName === 'aoyama') {
    const patternIdsForChildren = ['ab', 'bf'];
    const patternIdsForSibling = ['x', 'bb'];
    const patternIdsForSiblingTemplate = ['x', 'bb'];

    if (!is2Page) {
      if (patternIdsForChildren.includes(id) && hasChildren) {
        id = `${id}${book.childToParent.children}`;
      } else if (patternIdsForSiblingTemplate.includes(id) && hasSiblingTemplate) {
        id = `${id}${book.childToParent.siblingTemplate}`;
      }
    } else {
      if (patternIdsForSibling.includes(id) && hasSibling) {
        id = `${id}${book.childToParent.sibling}`;
      }
    }
  }
  if (artistName === 'okuta') {

    const patternIdsForChildren = ['ab', 'bf'];
    const patternIdsForChildren_2Page = ['ab', 'bf'];//2ページ目が複数・1ページ目より少ない2枚目を流用して子供の数が3以降も使う
    const patternIdsForProductType = ['e', 'ai'];//2ページ目がProductTypeによって違う
    const patternIdsForSibling = ['x', 'bb'];
    const patternIdsForSiblingTemplate = ['x', 'bb'];

    if (!is2Page) {
      if (patternIdsForChildren.includes(id) && hasChildren) {
        id = `${id}${book.childToParent.children}`;
      } else if (patternIdsForSiblingTemplate.includes(id) && hasSiblingTemplate) {
        id = `${id}${book.childToParent.siblingTemplate}`;
      }
    } else {
      if (patternIdsForChildren_2Page.includes(id) && hasChildren) {
        //子供の人数によって2ページ目も変わるが、2人目以降は同じ画像
        if (book.childToParent.children >= 2) {
          id = `${id}2`;
        } else {
          id = `${id}${book.childToParent.children}`;
        }
      } else if (patternIdsForSiblingTemplate.includes(id) && hasSiblingTemplate) {
        id = `${id}${book.childToParent.siblingTemplate}`;
      } else if (patternIdsForProductType.includes(id) && productType === "child_to_parents") {
        id = `${id}1`;
      } else if (patternIdsForProductType.includes(id) && productType === "child_to_parent") {
        id = `${id}2`;
      } else if (patternIdsForSibling.includes(id) && hasSibling) {
        id = `${id}${book.childToParent.sibling}`;
      }
    }
  }
  return imgs[artistName][is2Page ? `${id}i2` : id];
}

const Story = ({ artistName, book, id }) => (
  <div className="story">
    <div
      style={{
        background: "white",
        display: "inline-block",
        marginBottom: "5px",
        padding: "5px 12px"
      }}
    >{`ストーリー ${storyTitles[artistName][id]}`}</div>
    <div
      className="f-14 lh-24"
      style={{ background: "white", padding: "15px 12px" }}
      //dangerouslySetInnerHTML={{ __html: adapt(stories[id], book) }}
      dangerouslySetInnerHTML={
        artistName === 'aoyama'
          ? { __html: adapt(stories.aoyama[id], book) }
          : { __html: adapt(stories.okuta[id], book) }
      }
    />
    <br />
    <div style={{ overflowX: "scroll" }}>
      <div style={{ width: "180%" }}>
        <img
          style={{ float: "left" }}
          src={getImg(book, id)}
        />
        <img
          style={{ float: "right" }}
          src={getImg(book, id, true)}
        />
      </div>
    </div>
  </div>
);

class StoryList extends React.Component {
  constructor() {
    super();
    this.state = { visible: false };
  }

  handleCancel = e => {
    this.setState({ visible: false });
  };

  handleNext = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) + 1] });
  };

  handlePrevious = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) - 1] });
  };

  handleSelect = e => {
    this.props.onSelect(this.state.current);
    this.setState({ visible: false });
  };

  handleShowModal = () => {
    this.setState({ visible: true });
  };

  componentWillMount() {
    this.setState({ current: this.props.selected || this.props.list[0] });
  }

  componentWillReceiveProps(props) {
    this.setState({ current: props.selected || props.list[0] });
  }

  render() {
    const current = this.state.current,
      { artistName, list, storyNumber } = this.props,
      prev = list.indexOf(current) === 0,
      next = list.indexOf(current) === list.length - 1;
    // console.log({current}, this.state.current);

    return (
      <div>
        <div className="story-list link" onClick={this.handleShowModal}>
          <Icon
            type={this.props.selected ? "check-circle" : "edit"}
            style={{ float: "left", marginRight: "5px" }}
            theme="outlined"
          />
          {`ストーリー${storyNumber} `}
          <span className="f-12">{"（見開き2ページ分）"}</span>
          <Icon type="right" />
        </div>
        <Modal
          onCancel={this.handleCancel}
          bodyStyle={{ padding: "10px 0px", background: "#F6F4F9" }}
          //style={{ top: 5 }}
          visible={this.state.visible}
          footer={null}
        >
          <Row className="story-list">
            <Col span={1} />
            <Col span={22}>
              <br />
              <br />
              <Story
                artistName={artistName}
                book={this.props.book}
                id={current}
                stories={stories}
              />
              {"※顔画像はサンプルになります"}
              <br />
              <br />
              <Row className="story-list" type="flex" justify="space-around">
                <Col span={4} onClick={prev ? null : this.handlePrevious}>
                  <Icon
                    style={{
                      color: prev ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "left",
                      marginTop: "9px"
                    }}
                    type="left"
                  />
                  <span style={{ top: "11px", position: "relative" }}>
                    前へ
                  </span>
                </Col>
                <Col span={16} style={{ width: "170px" }}>
                  <Button
                    disabled={
                      this.props.disabled.indexOf(this.state.current) !== -1
                    }
                    key="submit"
                    type="primary"
                    onClick={this.handleSelect}
                    style={{
                      width: "170px",
                      padding: "10px",
                      height: "auto"
                    }}
                  >
                    {this.props.disabled.indexOf(this.state.current) !== -1
                      ? "選択済み"
                      : "このストーリーを選ぶ"}
                  </Button>
                </Col>
                <Col span={4} onClick={next ? null : this.handleNext}>
                  <span style={{ top: "11px", position: "relative" }}>
                    次へ
                  </span>
                  <Icon
                    style={{
                      color: next ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "right",
                      marginTop: "9px"
                    }}
                    type="right"
                  />
                </Col>
              </Row>
              <br />
            </Col>
            <Col span={1} />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default observer(StoryList);



// WEBPACK FOOTER //
// ./src/components/StorylistChildToParent.js